import React from 'react'
import PropTypes from 'prop-types'
import Configurator from '../../configurator'
import {
    DEVICE_ANDROID,
    DEVICE_IOS,
} from '../../consts'
import { navigatorDevice } from '../../events-webview'

const getItOnGooglePlay = '/images/get_it_on_google_play.svg'
const getItOnAppStore = '/images/get_it_on_app_store.svg'

export default class MobileStoreLink extends Configurator {

    /**
     * Get config params for button component
     * @returns {{imageUrl, link}|null}
     */
    getConfigForComponent = () => {
        const { forDevice } = this.props

        const {
            REACT_APP_ANDROID_STORE,
            REACT_APP_IOS_STORE,
        } = this.config

        switch (forDevice) {
            case DEVICE_ANDROID:
                return {
                    imageUrl: getItOnGooglePlay,
                    link: REACT_APP_ANDROID_STORE,
                }
            case DEVICE_IOS:
                return {
                    imageUrl: getItOnAppStore,
                    link: REACT_APP_IOS_STORE,
                }
            default:
                return null
        }
    }

    /**
     * Return true, if can be rendered in IOS
     * @returns {boolean}
     */
    canRenderInIOS = () => {
        const { forDevice } = this.props

        if (forDevice === DEVICE_ANDROID) {
            const isIOSSystem = navigator.userAgent.match(/(iPod|iPhone|iPad)/) && navigator.userAgent.match(/AppleWebKit/)
            const isIOSMobileApp = navigatorDevice === DEVICE_IOS

            // Dont render Google Play link in iOS browser or iOS app
            return !(isIOSSystem || isIOSMobileApp)
        }

        return true
    }

    render() {
        const buttonParams = this.getConfigForComponent()

        if (!buttonParams || !this.canRenderInIOS()) {
            return null
        }

        const {
            imageUrl,
            link,
        } = buttonParams

        const {
            className,
            linkClassName,
        } = this.props

        return (
            <div className={className}>
                <a href={link} target="_blank" rel="noopener noreferrer" className={linkClassName}>
                    <img src={imageUrl} alt="" />
                </a>
            </div>
        )
    }
}

MobileStoreLink.propTypes = {
    forDevice: PropTypes.string.isRequired,
}
